import React from 'react';
import './settingPayment.scss';

const SettingPayment = ({guildId, guildName}) => {
  return (
    <div className="setting_component_wrap_content setting_component_wrap_content_payment">
      <h3>Payment</h3>
      <div className="setting_component_item">
        <div className="setting_component_item_header">
          <h4>Paid via</h4>
          <p>Select a payment method</p>
        </div>
        <div className="setting_component_item_body">
          <div className="setting_component_item_body_bg">
            <img src="/img/visa.svg" alt="" />
            <p>ending 5483</p>
          </div>
        </div>
        <div className="setting_component_item_alert">
          <img src="/img/info.svg" alt="" />
          <p>
            Make sure to keep this payment method updated, as your backup payment method will not be
            used for this subscription.
          </p>
        </div>
      </div>
      <div className="setting_component_item">
        <div className="setting_component_item_header">
          <h4>Guild ID</h4>
          <p>ID of this server</p>
        </div>
        <div className="setting_component_item_body">
          <div className="setting_component_item_body_bg">
            <p>{guildId}</p>
          </div>
        </div>
      </div>
      <div className="setting_component_item">
        <div className="setting_component_item_header">
          <h4>Guild Name</h4>
          <p>The name of this server</p>
        </div>
        <div className="setting_component_item_body">
          <div className="setting_component_item_body_bg">
            <p>{guildName}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingPayment;
